// Public contact portal hosts. The contactportal.home.enabled flag gates the portal home ONLY when the SPA is
// served from one of these; every other host (AFD endpoints, App Service hosts, localhost) is unaffected.
//   prod https://contact.microsoft.com       ppe https://contact-ppe.microsoft.com
//   npe  https://contact-npe.microsoft.com   int https://contact-int.microsoft.com
const CONTACT_PORTAL_HOST_RE = /^contact(?:-(?:int|npe|ppe))?\.microsoft\.com$/i;

export function isContactPortalHost(hostname: string = window.location.hostname): boolean {
  return CONTACT_PORTAL_HOST_RE.test(hostname);
}
